// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSnackbarContent-root {
    width: 48rem;
    background-color: var(--public-portal-card);
}

.MuiSnackbarContent-message {
    width: 40rem;
    color: #636363;
}

.MuiSnackbarContent-action {
    padding: 10px;
    width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/cookieConsent/CookieConsent.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".MuiSnackbarContent-root {\n    width: 48rem;\n    background-color: var(--public-portal-card);\n}\n\n.MuiSnackbarContent-message {\n    width: 40rem;\n    color: #636363;\n}\n\n.MuiSnackbarContent-action {\n    padding: 10px;\n    width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
